import { useState } from "react";

export function useLocalStorageState(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return stored == null ? initialValue : JSON.parse(stored);
    } catch {
      return initialValue;
    }
  });

  const update = next => {
    setValue(previous => {
      const resolved = typeof next === "function" ? next(previous) : next;
      try { window.localStorage.setItem(key, JSON.stringify(resolved)); } catch { /* 저장 불가 환경에서는 상태만 유지 */ }
      return resolved;
    });
  };

  return [value, update];
}

